import DOMPurify from 'dompurify';

/**
 * Sanitize a string to prevent XSS attacks
 * @param {string} input - The input string to sanitize
 * @returns {string} Sanitized string
 */
export const sanitizeInput = (input) => {
  if (!input) return '';
  
  // First convert the input to a string if it's not already
  const stringInput = String(input);
  
  // Use DOMPurify to remove any HTML/script tags
  const purified = DOMPurify.sanitize(stringInput, { 
    ALLOWED_TAGS: [], // Don't allow any HTML tags
    ALLOWED_ATTR: [] // Don't allow any HTML attributes
  });
  
  // Additional checks for common XSS patterns
  const sanitized = purified
    .replace(/javascript:/gi, '') // Remove javascript: protocol
    .replace(/data:/gi, '') // Remove data: URI scheme
    .replace(/vbscript:/gi, '') // Remove vbscript: protocol
    .trim();
  
  return sanitized;
};

/**
 * Sanitize and validate player name
 * @param {string} name - The player name to sanitize
 * @returns {string} Sanitized player name
 */
export const sanitizePlayerName = (name) => {
  if (!name) return '';
  
  const sanitized = sanitizeInput(name);
  
  // Additional player name specific validations
  // For example, limit length
  if (sanitized.length > 20) {
    return sanitized.substring(0, 20);
  }
  
  return sanitized;
}; 